import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
               
                primaryColor: "#1f60ca",
                secondaryColor:'#10559A',
                // primaryColor: "#31efb0",
                

            },
        }
    },
});